<div class="notification-container flex flex-col gap-3">
  <div class="flex flex-row justify-between">
    <h4>Activity Feed</h4>
    <mat-slide-toggle
      data-test-id="notification-priority-filter"
      (change)="priorityToggleChange($event)"
    >
      <h4>Priority</h4>
    </mat-slide-toggle>
  </div>

  @if (notifications$ | async; as notifications) {
    <div class="content-container flex flex-col gap-4">
      @for (notification of notifications; track notification) {
        <div class="flex flex-col gap-2" data-test-id="notification-date-group">
          <span class="time" data-test-id="notification-date-created">{{
            notification.date
          }}</span>
          @for (item of notification.notifications; track item) {
            <app-notification
              [notification]="item"
              (archiveNotification)="archiveNotification($event)"
              (routeAction)="routeAction($event, item)"
            ></app-notification>
          }
        </div>
      }
      @if (!loading) {
        @if (!loggedIn) {
          <div class="empty-notifications">
            <p>Log in to view events</p>
          </div>
        }
        @if (loggedIn && !notifications.length) {
          <div class="empty-notifications" data-test-id="empty-notifications">
            <p>No notifications at the moment</p>
          </div>
        }
      } @else {
        <mat-spinner></mat-spinner>
      }
    </div>
  }
</div>
